import { useEffect } from 'react';
import { updateSelectedUTC } from '../redux/conditionsSlice';
import { useAppDispatch, useAppSelector } from '../redux/helpers';

/**
 * Seeds `conditions.selectedUTC` with the current interval whenever a condition overlay becomes
 * active. Nothing conditions-related renders until it is set — `DayAndTimeControls` returns null
 * without it, taking the day picker, time scrubber and play button with it — so any surface that
 * offers a conditions overlay has to call this.
 *
 * @param intervalMs How far apart the selectable times are, matching what the surface hands its
 * legend and playback.
 */
const useInitializeSelectedUTC = (intervalMs: number) => {
  const dispatch = useAppDispatch();
  const isConditionActive = useAppSelector(state => Boolean(state.conditions.activeCondition));

  useEffect(() => {
    if (isConditionActive) {
      dispatch(updateSelectedUTC(Math.floor(Date.now() / intervalMs) * intervalMs));
    }
  }, [dispatch, intervalMs, isConditionActive]);
};

export default useInitializeSelectedUTC;
